module.exports = __webpack_public_path__ + "img/service_en.bf7593fe.png";